import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import FormView from 'scoreboard/components/form-view'
import template from './filters-selection.hbs'
import config from 'scoreboard/components/config'
import selects from 'scoreboard/components/selects'
import i18n from 'scoreboard/components/i18n'
import OrFilterView from 'scoreboard/reports/common/filter/or-filter'

/**
 * This view is the filter selection step in the generic wizard inside the report wizard
 */
let Filters = Backbone.View.extend({

	tagName: 'form',

	events: {
		'change [name=fieldId]': 'changeField'
	},

	className: 'report-filters',

	initialize: function(options = {}) {
		this.options = options

		this.formView = new FormView({
			el: this.el,
			guard: false,
			validate: this.validate.bind(this),
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		})

		// #13004 hide score filter if scores should not be visible
		if (!this.options.meta) {
			throw new Error('Must define the filter meta data for filter selection')
		}
		let meta = this.options.meta
		this.filterMeta = _.clone(meta)
		if (!config.scoresVisible) {
			delete this.filterMeta['score']
		}

		// bubble up the filter form view validation tests from the inlined filter details (if any)
		this.formView.test = _.wrap(this.formView.test, test => {
			if (!this.filterDetailView) {
				return test.apply(this)
			}
			if (_.result(this.orFilterView, 'filter.linkGroup', null) == null) {
				return i18n.get('datasets.orGroup.required')
			}
			//if the filter defines specific validation use it, otherwise failback on validation over the entire view
			let testFunc = this.filterDetailView.formTest || test
			return testFunc.apply(this.filterDetailView)
		})

		//#24699 Default report filter to "specific scorecard items"
		let defaultSelectionMetaKeys = ['scorecardNodeIds','initiativeIds']
		let defaultFilterMetaKey = _.find(defaultSelectionMetaKeys, metaKey => meta[metaKey])
		if (defaultFilterMetaKey) {
			this._initialFilterKey = defaultFilterMetaKey
		}

		//map of the options per filter
		this.filterOptions = {}
	},

	render: function() {
		this.$el.html(template(this.options))

		let selectsData = {
			groupBy: _.get(this.options, 'groupBy', 'group'),
			options: _.reduce(this.filterMeta, (result, val, filterKey) => {
				if (val.filterType) {
					let selected = !_.isNil(this._initialFilterKey) && this._initialFilterKey == filterKey
					result.push({label: i18n.get(val.nameCode), value: filterKey,
						group: i18n.get(val.groupCode), selected})
				}
				return result
			}, [])
		}
		// create the select
		selects.filtering(this.$('select[name=fieldId]'), selectsData)

		this.options.wizard.render({ formView: this.formView })
		this.formView.start()

		this.changeField()

		return this
	},

	changeField: function(e) {
		var fieldId = this.$('[name=fieldId]').val()
		// only show the Filter Type dropdown if a field is chosen
		this.$('.inlined-filter-content').toggleClass('is-not-displayed', _.isEmpty(fieldId))

		if (this._initialFilterKey) {
			fieldId = this._initialFilterKey
			delete this._initialFilterKey
			this.formView.change()
		}

		//do nothing if same filter
		if (this.filterKey === fieldId || _.isNil(this.filterKey) && _.isEmpty(fieldId)) {
			return
		}

		this.filterDetailView && this.filterDetailView.remove()
		this.orFilterView && this.orFilterView.remove()
		delete this.filterDetailView
		delete this.filterKey
		let meta

		if (!_.isEmpty(fieldId)) {
			this.filterKey = fieldId

			//get metadata associated with a particular filter
			meta = this.filterMeta[this.filterKey]
			//build the options to generate the view for the filter
			this.filterOptions[this.filterKey] = _.defaults(_.cloneDeep(meta.formOptions || {}), {
				view: meta.form,
				dataType: meta.dataType,
				orgId: this.options.organizationId,
				filters: this.options.filters,
				filterKey: this.filterKey,
				massEdit: this.options.massEdit
			}, meta)

			//handles inline (within the current dialog) filters
 			if (meta.allowInlineDisplay !== false && !meta.path) {
				//load initial data if provided
				if (meta.seed && !this.filterOptions.seedData) {
					$.get({ url: meta.seed }).done(data => {
						this.filterOptions[this.filterKey].seedData = data
						this._renderFilterDetail(e, meta.form, this.filterOptions[this.filterKey])
					})
				} else {
					this._renderFilterDetail(e, meta.form, this.filterOptions[this.filterKey])
				}

				//setup the "OR"ing of filters
				this.orFilterView = new OrFilterView(_.defaults({
					meta: this.filterMeta,		//ensure the correct meta is used
					filterKey: this.filterKey
				}, this.options))
				this.$('.or-filter-content').html(this.orFilterView.el)
				this.orFilterView.render()

				//wire the changes from the or filter
				this.listenTo(this.orFilterView, 'toggle change', this.formView.change.bind(this.formView))
			}
		}
		this.formView.clearErrors()

		if (meta) {
			this.trigger('change:filterMeta', meta)
		}
	},

	_renderFilterDetail: function(e, view, viewOpts) {
		let vopts = _.assign({data: {}, formView: this.formView}, viewOpts)
		if (!vopts.data.range) {
			vopts.data.range = this.options.range
		}
		this.filterDetailView = new view(vopts).render()
		this.$('.inlined-filter-content').html(this.filterDetailView.el)

		// if this filter defines a custom form test, provide reference to test function to hook
		// into this's view's form validation
		if (this.filterDetailView.formViewType) {
			this.filterDetailView.formTest = new this.filterDetailView.formViewType().test
		}
		// some view may define a test method directly
		if (!this.filterDetailView.formTest && this.filterDetailView.test) {
			this.filterDetailView.formTest = this.filterDetailView.test
		}

		//if the view triggers it's own change, pass that along
		this.listenTo(this.filterDetailView, 'change', this.formView.change.bind(this.formView))

		this.formView.change(e)
	},


	validate: function() {
		return _.isNil(this.filterKey)
	},

	submit: function() {
		let { filterData } = this
		if (this.filterDetailView) {
			filterData =
				_.assign({}, this.orFilterView.filter, this.filterDetailView.gather())
		}
		this.trigger('next', this.filterOptions[this.filterKey], filterData)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.filterDetailView], 'remove')
		this.orFilterView && this.orFilterView.remove()
	}

})

export default Filters

Filters.__filename__ = 'reports/wizard/common/filters-selection.js'
